import { Pipe, PipeTransform } from '@angular/core';
import { BatchStatus } from '@batch/shared/models/batch';

@Pipe({
  name: 'statusChipClass'
})
export class StatusChipClassPipe implements PipeTransform {
  public transform(status: BatchStatus): string {
    switch (status) {
      case 'RECEIVED':
        return 'rs-chip--blue';
      case 'IN_PROGRESS':
        return 'rs-chip--orange';
      case 'CANCELLED':
        return 'rs-chip--grey';
      case 'INVALID':
      case 'FAILED':
        return 'rs-chip--red';
      case 'SUCCESS':
        return 'rs-chip--green';
      default:
        return '';
    }
  }
}
